import React from "react";
import Navb from "../../../../components/navbar/Navb";
import Footer from "../../../../components/footer/Footer";
import Img1 from "./img1.png";
import Recpiesimg1 from "./recpiesimg1.png";
import Recpiesimg2 from "./recpiesimg2.png";
import Recpiesimg3 from "../../img11.png";
import Recpiesimg4 from "../../img15.png";
import Recpiesimg5 from "../../img8.png";
import RecipiePage from "../../../../components/recipiePage/RecipiePage";
import Timer from "../timer.png";
import "../recipe.css";
const Wholeattavegmomos = () => {
  return (
    <>
      <RecipiePage
        Recpiesimg1={Recpiesimg1}
        Recpiesimg2={Recpiesimg2}
        Recpiesimg3={Recpiesimg3}
        Recpiesimg4={Recpiesimg4}
        Recpiesimg5={Recpiesimg5}
        Img1={Img1}
        Name="Whole Atta Veg Momos"
        Ul1={
          <ul>
            <li>
              <span className="Bold">Nandi whole wheat flour (atta)</span>
            </li>
            <li>Grated ginger</li>
            <li>Soy sauce</li>
            <li>Oil</li>
            <li>Water</li>
            <li>salt</li>
          </ul>
        }
        Ul2={
          <ul className="noDecoration">
            <li>1 cups</li>
            <li>1 tablespoon</li>
            <li>1 tablespoon</li>
            <li>1 tablespoon</li>
            <li>As needed</li>
            <li>as per taste</li>
          </ul>
        }
        Ul3={
          <ul>
            <li>Chopped mixed vegetables</li>
            <li>Finely chopped spring onions</li>

            <li>vinegar</li>
            <li>red chili sauce</li>
          </ul>
        }
        Ul4={
          <ul className="noDecoration">
            <li>1/2 cup</li>
            <li>1/4 cup</li>

            <li>1 tablespoon</li>
            <li>1 tablespoon</li>
            {/* <li>required amount</li> */}
          </ul>
        }
        Ol1={
          <ol>
            <li>
              Heat oil in a pan. Add grated ginger and sauté for a minute.
            </li>
            <li>
              Add finely chopped spring onions and cook until they become
              translucent.
            </li>
            <li>
              Add mixed vegetables and cook for a few minutes until they are
              slightly tender but still crisp.
            </li>
            <li>
              Add grated paneer, soy sauce, vinegar, red chili sauce, salt, and
              pepper. Mix well and cook for another 2-3 minutes. The filling
              should be slightly moist but not watery.
            </li>
            <li>Allow the filling to cool completely.</li>

            <li>
              Take small portions of the dough and roll them into small circles.
            </li>
            <li>
              Place a spoonful of the vegetable filling in the center of each
              circle.
            </li>
            <li>
              Fold the edges to form a half-moon shape and seal the edges by
              pinching them together.
            </li>
            <li>
              Steam the momos for about 15-20 minutes until the outer layer
              becomes translucent.
            </li>
            <li>
              Serve the Whole Wheat Veg Momos hot with a dipping sauce of your
              choice.
            </li>
          </ol>
        }
        Item1="Dalia Khichadi"
        Item2="Sooji Dhokla"
        Item3="Sooji and Vegitable Cheela"
        Link1="daliakhichadi"
        Link2="soojidhokla"
        Link3="sojivegcheela"
      />
{/* 
      <Navb />
      <div className="singleRecipeTop">Whole Atta Veg Momos</div>
      <img className="singleRecipeTopimg" src={Recpiesimg1} alt="Recpiesimg1" />
      <div className="singleRecipeBot">
        <div className="singleRecipeBotLeftItems">
          <div className="singleRecipeBotLeftItemTitle">INGREDIENTS</div>
          <hr />
          <div className="singleRecipeBotLeftItem">
            <div className="singleRecipeBotLeftItemTop">For the Dough:</div>
            <ol>
              <li>
                cups{" "}
                <span className="Bold">
                  1 cup nandi whole wheat flour (atta)
                </span>{" "}
              </li>
              <li>Water (as needed)</li>
              <li>Salt to taste</li>
            </ol>
          </div>
          <div className="singleRecipeBotLeftItem">
            <div className="singleRecipeBotLeftItemTop">For the Filling:</div>
            <ol>
              For the Filling:
              <li>
                1 cup finely chopped mixed vegetables (carrots, cabbage, bell
                peppers, etc.)
              </li>
              <li>1/2 cup grated paneer (cottage cheese)</li>
              <li>1/4 cup finely chopped spring onions</li>
              <li>1 tablespoon grated ginger</li>
              <li>1 tablespoon soy sauce</li>
              <li>1 tablespoon oil</li>
              <li>1 teaspoon vinegar</li>
              <li>1 teaspoon red chili sauce (adjust to taste)</li>
              <li>Salt and pepper to taste</li>
            </ol>
          </div>
          <hr />
          <div className="flexitemrecipe">
            <img src={Recpiesimg2} alt="Recpiesimg2" />
            Nandi Chakki Fresh Atta
          </div>
        </div>
        <div className="singleRecipeBotRight">
          <div className="singleRecipeBotRightTop">Instructions</div>
          <div className="singleRecipeBotRightTop">For the Filling:</div>
          <ol>
            <li>
              Heat oil in a pan. Add grated ginger and sauté for a minute.
            </li>
            <li>
              Add finely chopped spring onions and cook until they become
              translucent.
            </li>
            <li>
              Add mixed vegetables and cook for a few minutes until they are
              slightly tender but still crisp.
            </li>
            <li>
              Add grated paneer, soy sauce, vinegar, red chili sauce, salt, and
              pepper. Mix well and cook for another 2-3 minutes. The filling
              should be slightly moist but not watery.
            </li>
            <li>Allow the filling to cool completely.</li>
          </ol>
          <div className="singleRecipeBotRightTop">Assembling Momos:</div>
          <ol>
            <li>
              Take small portions of the dough and roll them into small circles.
            </li>
            <li>
              Place a spoonful of the vegetable filling in the center of each
              circle.
            </li>
            <li>
              Fold the edges to form a half-moon shape and seal the edges by
              pinching them together.
            </li>
            <li>
              Steam the momos for about 15-20 minutes until the outer layer
              becomes translucent.
            </li>
            <li>
              Serve the Whole Wheat Veg Momos hot with a dipping sauce of your
              choice.
            </li>
          </ol>
        </div>
      </div>
      <div className="singleRecipeEnd">
        <div className="singleRecipeEndTitle">You Might Also Like</div>
        <div className="singleRecipeEndItems">
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/maidavegpizzacones">
                <img src={Recpiesimg3} alt="Recpiesimg3" />
                <div className="singleRecipeEndItemTitle">Maida Pizza Cone</div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 40 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/mixvegparatha">
                <img src={Recpiesimg4} alt="Recpiesimg4" />
                <div className="singleRecipeEndItemTitle">Mix Veg Paratha</div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 50 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/besanburfi ">
                <img src={Recpiesimg5} alt="Recpiesimg5" />
                <div className="singleRecipeEndItemTitle">Besan burfi</div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 600 mins</span>
            </div>
          </div>
        </div>
      </div>
      <Footer /> */}
    </>
  );
};

export default Wholeattavegmomos;
